module.exports = __webpack_public_path__ + "img/Weapon_159.7f9af077.png";